import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'floatingScreenBackgroundImagePath',
  initialState: null as string | null,
  reducers: {
    setFloatingScreenBackgroundImagePath(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFloatingScreenBackgroundImagePath } = slice.actions;

export default slice.reducer;
